import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from "react-router-dom";
import {ModeleClientContact, modeleClientContactInitValues} from "../../../../../../components/Models";
import {editClientContact, getClientContact} from "../../../../../../components/requests";
import {ClientContactForm} from "../../components/ClientContactForm";
import {LoadingData} from "../../../../../../components/LoadingData";

const ClientContactEdit = () => {
  const navigate = useNavigate();
  let {clientId} = useParams();
  let {contactId} = useParams();
  const [data, setData] = useState<ModeleClientContact>(modeleClientContactInitValues);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getClientContactData()
  }, [clientId, contactId]);

  const getClientContactData = () => {
    getClientContact(clientId, contactId).then(clientContactRequest => {
      if (clientContactRequest?.status === 200) {
        if (clientContactRequest?.data?.id !== undefined && clientContactRequest?.data?.id !== null) {
          const updatedData = Object.assign({...data}, clientContactRequest?.data)
          setData({...updatedData})
        }
        setLoading(false);
      } else {
        navigate(`/vente/clients/${clientId}/afficher/contacts`);
      }
    });
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleClientContact>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleClientContactInitValues}, fieldsToUpdate)

    var requestOk = false;
    try {
      const clientContactRequest = await editClientContact(clientId, contactId, updatedData);
      if (clientContactRequest?.status === 200) {
        if (clientContactRequest?.data?.id !== undefined && clientContactRequest?.data?.id !== null) {
          requestOk = true;
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
      if (requestOk) {
        setData({...updatedData})
        navigate(`/vente/clients/${clientId}/afficher/contacts`);
      }
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Modifier un contact</h3>
        </div>
      </div>

      <div>
        {loading
          ?
          <LoadingData/>
          :
          <ClientContactForm clientId={clientId} contactId={contactId} data={data} submitForm={submitForm}/>
        }
      </div>
    </div>
  )
}

export {ClientContactEdit}
